import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/es'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('es')

dayjs.tz.setDefault(dayjs.tz.guess())

const formatDate = (value: dayjs.ConfigType, format: string = 'dddd DD.MM.YYYY - HH:mm [hs.]') => {
    return dayjs(value).format(format)
}

const now = () => {
    return dayjs().format()
}

const dateDiff = (a: string | number | Date, b: string | number | Date, unit?: dayjs.UnitType) => {
    return dayjs(a).diff(b, unit)
}

export { now, formatDate, dateDiff }
